import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './List.css';

import PropertySort from '../PropertySort/PropertySort';
import ListItem from './ListItem';
import ListMenu from './ListMenu';
import { storage } from '../../config';

export class ListComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortDisplay: false,
      menu: false,
    };
    // Need a &nbsp; to give the anchor some height. Otherwise
    // it won't trigger the see more.
    this.anchor = null;
    this.showSortOptions = this.showSortOptions.bind(this);
    this.checkSpace = this.checkSpace.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { properties } = this.props;
    const nextProperties = nextProps.properties;
    if (nextProperties && nextProperties.length > properties.length) {
      this.setState({ waiting: false });
    }
  }

  showSortOptions() {
    this.setState({ sortDisplay: !this.state.sortDisplay });
  }

  showMenu() {
    this.setState({ menu: !this.state.menu });
  }

  checkSpace() {
    const { addMoreViewable } = this.props;
    if (!this.anchor) {
      return;
    }

    if (this.anchor &&
      this.anchor.getBoundingClientRect().top < (window.innerHeight)
    ) {
      addMoreViewable();
    }
  }

  formatSortType(sortType) {
    let name;
    switch (sortType) {
      case 'sqft high':
        name = 'Sqft High';
        break;
      case 'sqft low':
        name = 'Sqft Low';
        break;
      case 'acres high':
        name = 'Acres High';
        break;
      case 'acres low':
        name = 'Acres Low';
        break;
      case 'name high':
        name = 'Name Z-A';
        break;
      case 'name low':
        name = 'Name A-Z';
        break;
      case 'nearestAirport low':
        name = 'Closest Airport';
        break;
      case 'nearestInterstate low':
        name = 'Closest Interstate';
        break;
      default:
      //
    }
    return name;
  }

  render() {
    const {
      additionalSort,
      handleModalOpen,
      handleSort,
      isMobile,
      loading,
      properties,
      sortType,
      total,
      type,
      listLoading,
    } = this.props;
    return (
      <div
        onScroll={this.checkSpace}
        className="list list-container"
      >
        <div className="list-sort-bar">
          <div className="list-sort-bar-inner">
            <strong>Showing</strong> {properties.length} of {total} {type} by
            <a
              onClick={() => { this.showSortOptions(); }}
              className="list-sort-toggle"
              tabIndex="0"
            >
              <strong> { this.formatSortType(sortType) }</strong> <span />
            </a>
          </div>

          <ListMenu
            properties={properties}
            type={type}
            handleModalOpen={handleModalOpen}
          />
        </div>
        {this.state.sortDisplay && <PropertySort
          applied={sortType}
          handleSort={handleSort}
          additionalSort={additionalSort}
          onSelected={this.showSortOptions}
        />
        }
        {this.state.menu &&
        <ListMenu
          properties={properties}
          type={type}
          handleModalOpen={handleModalOpen}
        />
        }
        <ul
          className="list-wrapper list-container__list"
        >
          {properties.map(property => {
            return (
              <ListItem
                key={property._id}
                property={property}
                type={type}
                isMobile={isMobile}
                handleModalOpen={handleModalOpen}
              />
            );
          })}
          <li
            ref={input => {
              this.anchor = input;
            }}
          >
            {(listLoading || loading) &&
            <img
              alt="loading gif"
              src={`${storage.distPath}/loading.gif`}
            />
            }
            &nbsp;
          </li>
        </ul>
      </div>
    );
  }
}

ListComponent.propTypes = {
  addMoreViewable: PropTypes.func,
  additionalSort: PropTypes.string,
  handleModalOpen: PropTypes.func,
  handleSort: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isMobile: PropTypes.bool,
  properties: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  total: PropTypes.number,
  listLoading: PropTypes.bool,
};

export default ListComponent;



// WEBPACK FOOTER //
// ./src/components/List/List.js